import Http from "./Http";

export default class Logger {
  static limit_time=20000;
  module_name=""
  start_time="";
  end_time="";
  group_name=""
  group_key=""
  group_val=""
  remarks=""
  path=""
  title=""
  constructor(_module_="") {
    this.module_name=_module_
  }

  start({
          group_name='',
          group_key='',
          group_val='',
          remarks=''
        }){
    const that=this;
    that.start_time=Number.parseInt((new Date().getTime()) / 1000);
    that.group_name=group_name;
    that.group_key=group_key;
    that.group_val=group_val;
    that.remarks=remarks;
    if(typeof __ERP__ !=="undefined"){
      that.path=((__ERP__||{}).$route||{}).path||""
      that.title=(((__ERP__||{}).$route||{}).meta||{}).title||""
    }
  }

  end(remarks=""){
    const that=this;
    that.end_time=Number.parseInt((new Date().getTime()) / 1000);
    that.remarks+=remarks;
    that.writeLog();
  }

  writeLog(){
    const that=this;
    let user_log=Logger.getStore('_user_log_')||[]
    let log={};
    log.start_time=that.start_time;
    log.end_time=that.end_time;
    log.group_name=that.group_name;
    log.group_key=that.group_key;
    log.group_val=that.group_val;
    log.module_name=that.module_name;
    log.remarks=that.remarks
    log.path=that.path
    log.title=that.title

    if(user_log.length>500){
      user_log.splice(0,1)
    }
    user_log.push(log);
    Logger.setStore('_user_log_',user_log)
  }
  static clearLog(){
    console.log("_user_log_","清空")
    Logger.setStore('_user_log_',[])
  }

  static push(){
    const that=this;
    let user_log=Logger.getStore('_user_log_')
    if(user_log&&user_log.length>0){
      Http.post("/logger/index/push",{user_log:JSON.stringify(user_log)},ret=>{
        if(ret.code===1){
          console.log(ret,ret.code)

        }
        Logger.clearLog();
        setTimeout(function () {
          Logger.push();
        },Logger.limit_time);
      })
    }else {
      setTimeout(function () {
        Logger.push()
      },Logger.limit_time);
    }
  }


  /**
   * 获取状态
   * @returns {*}
   */
  static getStore(key=null){
    if(key){
      let data=window.localStorage.getItem(key)
      if(data){
        try {
          data=JSON.parse(data);
        }catch (e) {

        }
      }
      return data;
    }else {
      return null;
    }
  }
  /**
   * 设置状态
   * @param key
   * @param val
   */
  static setStore(key,val){
    window.localStorage.setItem(key,JSON.stringify(val))
  }
}



// WEBPACK FOOTER //
// ./src/common/logger/Logger.js